import { getGeneralContentSlug } from "api"
import { getSiteIdByLocale } from "api/SiteId"
import { GetStaticProps } from "next"
import { NextSeo } from "next-seo"
import TemplatePage, {
  TemplatePageProps,
} from "../../components/template-page/TemplatePage"

const TermsOfUse = ({ data }) => {
  return (
    <>
      <NextSeo
        title={data?.metaTitle}
        description={data?.metaDescription}
        additionalMetaTags={[{ name: "keywords", content: data?.metaKeywords }]}
        openGraph={{
          title: data?.ogTitle || data?.metaTitle,
          description: data?.ogDescription || data?.metaDescription,
          images: [{ url: data?.ogImage?.media?.publicUrl || "" }],
        }}
      />
      <TemplatePage data={data} />
    </>
  )
}

export const getStaticProps: GetStaticProps<TemplatePageProps> = async ({
  locale,
}) => {
  const siteId = getSiteIdByLocale(locale)
  const response = await getGeneralContentSlug("terms-of-use", siteId) //to modify
  if (!response?.data) {
    return { notFound: true }
  }
  const { data } = response
  return {
    props: {
      messages: (await import(`../../messages/${locale}.json`)).default,
      data,
    },
    revalidate: 60,
  }
}

export default TermsOfUse
